module.exports = __webpack_public_path__ + "img/visualbanner.0688eb9a.png";